export const toggleSubNav = (event) => {
  const toggleButtonElement = event.target.getAttribute('aria-controls') ? event.target : event.target.parentNode
  const toggleItem = toggleButtonElement.getAttribute('aria-controls') ?? ''
  const toggleItemElement = document.getElementById(toggleItem);

  if (toggleItemElement) {
    toggleItemElement.classList.toggle('item-subnav-active')
    toggleItemElement.setAttribute('aria-hidden', toggleItemElement.getAttribute('aria-hidden') === 'true' ? 'false' : 'true')
    toggleItemElement.setAttribute('aria-expanded', !!toggleItemElement.getAttribute('aria-expanded') === 'true' ? 'false' : 'true')
    toggleItemElement.setAttribute('aria-selected', !!toggleItemElement.getAttribute('aria-selected') === 'true' ? 'false' : 'true')
  }

  if (toggleButtonElement) {
    toggleButtonElement.setAttribute('aria-expanded', !!toggleButtonElement.getAttribute('aria-expanded') === 'true' ? 'false' : 'true')
    toggleButtonElement.classList.toggle('link-item-active')
  }
  event.preventDefault()
  event.stopPropagation()
}

export const showDropdown = (event) => {
  const navItemElement = event.target
  const otherNavItemElement = document.querySelectorAll('.navigation .navbar .actions .nav-item .nav-link')

  if (otherNavItemElement) {
    otherNavItemElement.forEach((item) => {
      item.classList.remove('nav-link-active')
    })
  }
  if (navItemElement) {
    navItemElement.classList.add('nav-link-active')
  }

  const dropdownElement = event.target.parentNode
  const otherDropdownElement = document.querySelectorAll('.navigation .navbar .actions .nav-item.dropdown')

  if (otherDropdownElement) {
    otherDropdownElement.forEach((item) => {
      item.classList.remove('nav-dropdown-show')
    })
  }
  if (dropdownElement && dropdownElement.querySelector('.dropdown-menu')) {
    dropdownElement.classList.add('nav-dropdown-show')
  }
  event.preventDefault()
}

export const hideDropdown = (event) => {
  if (event.target.classList.contains('nav-link')) {
    const navItemElement = event.target
    const dropdownElement = event.target.parentNode
    if (navItemElement) {
      setTimeout(() => {
        if (dropdownElement && dropdownElement.classList.contains('nav-dropdown-show')) {
          return
        } else {
          navItemElement.classList.remove('nav-link-active')
        }
      }, 0)
    }
  } else if (event.target.classList.contains('dropdown-item')) {
    const dropdownElement = event.target.parentNode.parentNode.parentNode.parentNode
    if (dropdownElement) {
      dropdownElement.classList.remove('nav-dropdown-show')
    }
    const navItemElement = event.target.parentNode.parentNode.parentNode.parentNode.querySelector('.nav-link')
    if (navItemElement) {
      navItemElement.classList.remove('nav-link-active')
    }
  } else {
    const dropdownElement = event.target
    if (dropdownElement) {
      dropdownElement.classList.remove('nav-dropdown-show')
    }
    const navItemElement = event.target.querySelector('.nav-link')
    if (navItemElement) {
      navItemElement.classList.remove('nav-link-active')
    }
  }
}

export const navEvents = () => {
  if (typeof document === 'undefined') return
  const subNavToggleButtonElements = document.querySelectorAll('.navigation .navbar-mobile #mobile-nav-collapse .navbar-nav .nav-link.button-subnav-toggle');
  const navItemElements = document.querySelectorAll('.navigation .navbar .actions .nav-item .nav-link');
  const dropdownElements = document.querySelectorAll('.navigation .navbar .actions .nav-item.dropdown');
  const lastDropdownItemElements = document.querySelectorAll('.navigation .navbar .actions .nav-item.dropdown .dropdown-menu ul li:last-child .dropdown-item');

  if (subNavToggleButtonElements) {
    subNavToggleButtonElements.forEach((item) => {
      item.addEventListener('click', toggleSubNav)
    })
  }

  if (navItemElements) {
    navItemElements.forEach((item) => {
      item.addEventListener('mouseenter', showDropdown)
      item.addEventListener('focus', showDropdown)
      item.addEventListener('mouseleave', hideDropdown)
    })
  }

  if (dropdownElements) {
    dropdownElements.forEach((item) => {
      item.addEventListener('mouseleave', hideDropdown)
    })
  }

  if (lastDropdownItemElements) {
    lastDropdownItemElements.forEach((item) => {
      item.addEventListener('blur', hideDropdown)
    })
  }

  const showGlobalSearchElement = document.getElementById('showGlobalSearch')
  if (showGlobalSearchElement) {
    showGlobalSearchElement.addEventListener('click', (event) => {
      const globalSearchElement = document.getElementById('globalSearchSection')
      if (globalSearchElement) {
        globalSearchElement.classList.remove('sr-only')
      }
      const globalSearchInput = document.getElementById('search-input')
      if (globalSearchInput) {
        globalSearchInput.focus()
      }
      event.preventDefault()
    })
  }
}